import { Component } from '@angular/core';

@Component({
  selector: 'app-editing-strategy',
  templateUrl: './editing-strategy.component.html',
  styleUrls: ['./editing-strategy.component.scss'],
  standalone: false
})
export class EditingStrategyComponent {}
